/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable no-param-reassign */
/* eslint-disable no-useless-escape */
/* eslint-disable react/prop-types */
import React from 'react';
import styles from './index.less';
import ToolbarItemImage from '../tool-bar/toolbar-item-image';
import { ActionType } from '../../../editor/src/js/constants/common-action-type';
import Divider from '@tencent/dui/lib/components/Divider';
import Provider from '../provider';
import { StyleMode } from '../../../editor/src/js/constants/float-toobbar-data';
import { IReactionDisposer, reaction } from 'mobx/lib/mobx';
import classNames from 'classnames';
import _debounce from 'lodash/debounce';
import { PPTEditorStateType } from '../../../../slide/domain/ui-model/constant/edit-state-type';
import { MenuType } from '../../../../slide/domain/ui-model/constant/menu';
import { IUserPriviledgeService } from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { ISubChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';

type IStates = {
    data: any;
};
type IProps = {
    noShadow?: boolean,
    userPriviledgeService: IUserPriviledgeService;
    menuManager?: IMenuManager;
    selectionService: ISelectionService;
};
/**
 * 对象快捷设置
 */
export default class ChartQuickSetting extends React.Component<IProps, IStates> {
    public static keyIndex = 0;
    private quickAutorun: IReactionDisposer;
    private selectedModel: any;
    private subCharts: ISubChartModel[];

    public constructor(props, context) {
        super(props, context);
        this.state = {
            data: this.getQuickSettingData(),
        };
        ChartQuickSetting.keyIndex += 1;
    }

    public componentDidMount(): void {
        this.quickAutorun = reaction(
            () => this.props.selectionService.getSelectedModel(),
            (selectedModel) => {
                if (this.selectedModel?.changeSetEngine) {
                    this.selectedModel.changeSetEngine.removeChangesetObserver(this.dataChange);
                    this.selectedModel.changeSetEngine.removeChangesetObserver(this.subChartChange);
                    const subCharts = this.selectedModel.plotArea?.charts;
                    this.removeSubChartObverver(subCharts);
                }
                this.selectedModel = selectedModel;
                if (this.selectedModel?.changeSetEngine) {
                    this.selectedModel.changeSetEngine.addChangesetObserver(this.dataChange);
                    this.selectedModel.changeSetEngine.addChangesetObserver(this.subChartChange);
                    const subCharts = this.selectedModel.plotArea?.charts;
                    this.subCharts = subCharts;
                    this.addSubChartObverver(subCharts);
                }
            },
            { fireImmediately: true },
        );
    }

    public componentWillUnmount(): void {
        this.quickAutorun?.();
        if (this.selectedModel?.changeSetEngine) {
            this.selectedModel.changeSetEngine.removeChangesetObserver(this.dataChange);
            this.selectedModel.changeSetEngine.removeChangesetObserver(this.subChartChange);
        }
    }

    // 加入防抖，避免重复计算。同时通过延迟来确保disableItemIds已更新成最新状态
    dataChange = _debounce(() => {
        const data = this.props.menuManager?.quickSetMenu();
        const disableItems = this.props.menuManager?.disableItemIds();
        const values = data?.values;
        this.updateValues(this.state.data.items, values, disableItems);
        this.setState({
            data: this.state.data,
        });
    });

    subChartChange = _debounce(() => {
        const subCharts = this.selectedModel.plotArea?.charts;
        if (this.subCharts !== subCharts) {
            this.removeSubChartObverver(this.subCharts);
            this.addSubChartObverver(subCharts);
            this.subCharts = subCharts;
        }
    });

    addSubChartObverver = (subCharts) => {
        if (subCharts && subCharts.length > 0) {
            subCharts.forEach((subChart) => {
                subChart.changeSetEngine.addChangesetObserver(this.dataChange);
            });
        }
    };

    removeSubChartObverver = (subCharts) => {
        if (subCharts && subCharts.length > 0) {
            subCharts.forEach((subChart) => {
                subChart.changeSetEngine.removeChangesetObserver(this.dataChange);
            });
        }
    };


    updateValues = (itemList, values, disableItems) => {
        const disableIDs = {};
        disableItems?.forEach?.((item) => {
            disableIDs[item.id] = true;
        });

        itemList?.forEach?.((item) => {
            const value = this.getItemValueForUpdataValues(values, item);
            if (typeof (value) !== 'undefined') {
                item.value = value;
            }

            if (disableIDs[item.id] && !item.enable) {
                // 通过显式设置Item的enable=true，可以覆盖固定的diable列表。
                item.disabled = true;
            } else {
                item.disabled = false;
            }
        });
    };

    getItemValueForUpdataValues(values, item) {
        return values?.[item.id];
    }

    getQuickSettingData() {
        const data = this.props.menuManager?.quickSetMenu();
        const disableItems =  this.props.menuManager?.disableItemIds();
        const values = data?.values;

        this.updateValues(data?.items, values, disableItems);

        return data;
    }

    handleClick = (id, value) => {
        if (this.props.userPriviledgeService.pptEditorState !== PPTEditorStateType.EDITABLE) {
            return;
        }
        const { callback } = this.state.data;
        const handleClickMap = {
            [ActionType.MOVE_ITEM]: () => {
                callback(MenuType.QUICK_SETTING, value, value);
            },
            [ActionType.MORE_SETTING]: () => {
                callback(MenuType.QUICK_SETTING, id, value);
            },
        };
        if (typeof (handleClickMap[id]) === 'function') {
            handleClickMap[id]();
        }
    };

    handleMultiItemClick = (menuType, id, value) => {
        this.handleClick(id, value);
    };

    handleMouseDown = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    render() {
        const { data } = this.state;
        if (!data?.items) {
            return null;
        }

        const { noShadow } = this.props;

        const items = Array.isArray(data.items) && data.items.map((item, i) => {
            if (item.id === ActionType.DIVIDER) {
                return (
                    <Divider key={i} orientation="vertical"
                        style={{ verticalAlign: 'middle', backgroundColor: 'rgba(0, 0, 0, 0.08)', margin: '0 4px' }}/>
                );
            }
            return (
                <ToolbarItemImage
                    key={`toolbarItem_${item.id}`}
                    {...item}
                    handleClick={this.handleClick}
                    model = {StyleMode.QUICK_SETTING}
                    keyIndex={ChartQuickSetting.keyIndex}
                    onItemClickCallBack = {this.handleMultiItemClick}
                    hideDropDownIcon={true}
                    noShadow={item.id === ActionType.EDIT_CHART_COMPONENT}
                    isChart
                />
            );
        });
        const itemClass = classNames({
            [styles.quickBar]: true,
            [styles['quickBar-shadow']]: !noShadow,
        });

        if (!items || items.length === 0) return null;

        return (
            <Provider>
                <div className={itemClass} onMouseDown={this.handleMouseDown}>{items}</div>
            </Provider>
        );
    }
}
